import React from 'react';

const emiFooter = () => (
    <div className={`u-textColorWhite`}>
        
    </div>
);

export default emiFooter;


// WEBPACK FOOTER //
// ./src/components/Payment/EMI/EMIFooter/EMIFooter.js